/** Short stable label for clicked element (best-effort, no PII). */
export function describeElement(target: EventTarget | null): string {
  if (!target || !(target instanceof Element)) return '(unknown)';
  const el = target instanceof HTMLElement ? target : target;
  const tag = el.tagName.toLowerCase();
  const tid = el.getAttribute('data-testid');
  if (tid) return `${tag}[data-testid="${tid}"]`;
  if (el.id) return `${tag}#${el.id}`;
  const role = el.getAttribute('role');
  if (role) return `${tag}[role="${role}"]`;
  const cls =
    typeof el.className === 'string' && el.className.trim()
      ? '.' +
        el.className
          .trim()
          .split(/\s+/)
          .filter((c) => !c.startsWith('css-') && !c.startsWith('jss'))
          .slice(0, 2)
          .join('.')
      : '';
  const aria = el.getAttribute('aria-label');
  if (aria) return `${tag}${cls}[aria-label]`.slice(0, 180);
  return `${tag}${cls}`.slice(0, 180);
}
